import { Grid, Typography, MenuItem } from "@material-ui/core";
import * as yup from 'yup';
import { useFormikContext, Field, FieldArray } from "formik";
import { TextField } from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
import { ProductSearch } from "components";
import { IssueServiceType } from "helpers/enums";
import { newTicketContext, newTicketSchema } from '../NewTicketContext';
import { useContext, useEffect } from "react";
import { applicationContext } from "helpers/services";
import { KeyValuePair } from "helpers";


let DeliveryInfo = () => {
    let { issueServiceTypes } = useContext(applicationContext);
    let { productSuppliers, updateProductSuppliers } = useContext(newTicketContext);

    type Ticket = yup.InferType<typeof newTicketSchema>;

    let form = useFormikContext<Ticket>();

    useEffect(() => {
        if (form.values.numberOfPackages) {
            let value = parseInt(form.values.numberOfPackages);
            let length = form.values.packageNumbers.length;

            if (value < 100 && value !== length) {
                // se il numero di pacchetti è minore del numero di textfield rimuovo l'ultimo
                // se è maggiore ne aggiungo uno
                if (value < length) {
                    let diff = length - value;
                    for (let i = 0; i < diff; i++)
                        form.values.packageNumbers.pop();
                }
                else {
                    let diff = value - length;
                    for (let i = 0; i < diff; i++)
                        form.values.packageNumbers.push('');
                }
            }
        }

    }, [form.values.packageNumbers, form.values.numberOfPackages])


    let handleChangeIssue = (value: string) => {
        form.setFieldValue('issueServiceType', value);
        //pulisco tutti i campi collegati alla tipologia di issue ad ogni cambio
        form.setFieldValue('numberOfPackages', 0);
        form.setFieldValue('packageNumbers', []);
        form.setFieldValue('productSku', '');
        form.setFieldValue('productBrand', '');
        form.setFieldValue('productDescription', '');
        form.setFieldValue('hasSerialNumber', false);
        form.setFieldValue('receivedQuantity', '');
        form.setFieldValue('damagedItemQuantity', '');

    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">Please provide these additional info</Typography>
            </Grid>
            <Grid container item xs={12}>
                <Field
                    component={TextField}
                    name="deliveryNote"
                    variant="outlined"
                    fullWidth
                    label="Delivery Note"
                />
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Field
                        component={DatePicker}
                        name="invoiceDate"
                        fullWidth
                        format="LL"
                        inputVariant="outlined"
                        label="Invoice Date"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="invoiceNumber"
                        fullWidth
                        variant="outlined"
                        label="Invoice Number"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="invoiceQuantity"
                        fullWidth
                        variant="outlined"
                        label="Invoice quantity"
                        type="number"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        select
                        name="issueServiceType"
                        label="Issue service type"
                        variant="outlined"
                        fullWidth
                        onChange={(e: any) => handleChangeIssue(e.target.value)}
                    >
                        {issueServiceTypes.map(issue =>
                            <MenuItem key={issue.key} value={issue.key}>{issue.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
                {(form.values.issueServiceType === IssueServiceType.DamagedPackages
                    || form.values.issueServiceType === IssueServiceType.MissingPackages) &&
                    <FieldArray name="packageNumbers">
                        {({ insert, remove }) =>
                            <>
                                <Grid container>
                                    <Grid item xs={5}>
                                        <Field
                                            component={TextField}
                                            name="numberOfPackages"
                                            fullWidth
                                            inputProps={{ max: 99 }}
                                            variant="outlined"
                                            label="Number of packages"
                                            type="number"
                                        />
                                    </Grid>
                                </Grid>
                                {form.values.packageNumbers
                                    .map((pkNumber, index) =>
                                        <Grid container key={index}>
                                            <Grid item xs={5}>
                                                <Field
                                                    label="Package number"
                                                    component={TextField}
                                                    name={`packageNumbers[${index}]`}
                                                    fullWidth
                                                    variant="outlined"
                                                    type="number"
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                            </>
                        }
                    </FieldArray>
                }

                {(form.values.issueServiceType === IssueServiceType.OvershippedItems
                    || form.values.issueServiceType === IssueServiceType.MissingItems
                    || form.values.issueServiceType === IssueServiceType.DamagedItems) &&
                    <>
                        <Grid item xs={8}>
                            <ProductSearch
                                label="Product"
                                freeSolo={false}
                                value={{
                                    value: form.values.productSku,
                                    label: `${form.values.productSku} ${form.values.productDescription}`.trim(),
                                    brand: form.values.productBrand,
                                    shortDescription: form.values.productDescription,
                                    sku: form.values.productSku,
                                    hasSerialNumber: form.values.hasSerialNumber,
                                    suppliers: []
                                }}
                                onChange={(sku: string, brand: string, description: string, hasSerialNumber: boolean, suppliers: KeyValuePair<string, string>[]) => {
                                    form.setFieldValue('productSku', sku);
                                    form.setFieldValue('productBrand', brand);
                                    form.setFieldValue('productDescription', description);
                                    form.setFieldValue('hasSerialNumber', hasSerialNumber);

                                    updateProductSuppliers(suppliers);

                                    if (suppliers.length === 1) {
                                        form.setFieldValue('productSupplierCode', suppliers[0].key);
                                        form.setFieldValue('productSupplierName', suppliers[0].value);
                                    }
                                }}
                                error={Boolean(form.touched.productSku && form.errors.productSku)}
                                helperText={form.touched.productSku ? form.errors.productSku : ''}
                            />
                        </Grid>
                        {(form.values.issueServiceType === IssueServiceType.OvershippedItems
                            || form.values.issueServiceType === IssueServiceType.MissingItems) &&
                            <Grid item xs>
                                <Field
                                    component={TextField}
                                    name="receivedQuantity"
                                    fullWidth
                                    variant="outlined"
                                    helperText='Enter the total quantity received'
                                    label="Received quantity"
                                    type="number"
                                />
                            </Grid>
                        }
                        {form.values.issueServiceType === IssueServiceType.DamagedItems &&
                            <Grid item xs>
                                <Field
                                    component={TextField}
                                    name="damagedItemQuantity"
                                    fullWidth
                                    helperText="Enter the quantity of item damaged"
                                    variant="outlined"
                                    label="Quantity of item damaged"
                                    type="number"
                                />
                            </Grid>
                        }
                        {productSuppliers.length > 1 &&
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    select
                                    name="productSupplierCode"
                                    variant="outlined"
                                    fullWidth
                                    label="Product supplier"
                                    onChange={(e: any) => {
                                        form.setFieldValue('productSupplierCode', e.target.value);
                                        form.setFieldValue('productSupplierName', productSuppliers.getValueByKey(e.target.value));
                                    }}
                                    helperText='Multiple suppliers'
                                >
                                    <MenuItem key='' value=''>Any</MenuItem>
                                    {productSuppliers.map((supplier, supplierIdx) =>
                                        <MenuItem key={supplierIdx} value={supplier.key}>{supplier.value}</MenuItem>
                                    )}
                                </Field>
                            </Grid>
                        }
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default DeliveryInfo;